import { createApp } from 'vue';
import { safeDefine } from '@breuni-ui/safe-define';
import vueDataVueComponent from './vueData.vue.component';
import '../../scripts/lib/EventBus.js';
import { readJsonFromDom } from '../../scripts/utils.js';

class BewertenVueData extends HTMLElement {
  connectedCallback() {
    const appRoot = document.querySelector('#bewerten-vue-pds');
    const productJSON = readJsonFromDom('#entsProductData');
    const syan = productJSON.syan;
    const article = productJSON.artikel;
    const initialKey = productJSON.artikelKey;
    const productDetailsJSON = readJsonFromDom('#entsProductDetailData');
    const eventTrackingJSON = readJsonFromDom('#entsEventTrackingData');
    const metaLanguageJSON = readJsonFromDom('#entsLanguageMetaData');
    const {
      alwaysDisplayCombiModule: rawAlwaysDisplayCombiModule,
      mandatedHost,
      cdnHost,
      wishlistApiTimeout: rawWishlistApiTimeout,
      fitaRecoCall: rawFitaRecocall,
      showChristmasBear: rawShowChristmasBear,
      isBreuningerReferrer: rawIsBreuningerReferrer
    } = this.dataset;
    const alwaysDisplayCombiModule = rawAlwaysDisplayCombiModule === 'true';
    const wishlistApiTimeout = parseInt(rawWishlistApiTimeout, 10);
    const fitaRecoCall = rawFitaRecocall === 'true';
    const showChristmasBear = rawShowChristmasBear === 'true';
    const isBreuningerReferrer = rawIsBreuningerReferrer === 'true';

    const app = createApp(
      vueDataVueComponent({
        syan,
        article,
        initialKey,
        productJSON,
        productDetailsJSON,
        eventTrackingJSON,
        metaLanguageJSON,
        alwaysDisplayCombiModule,
        appRoot,
        mandatedHost,
        cdnHost,
        wishlistApiTimeout,
        fitaRecoCall,
        showChristmasBear,
        isBreuningerReferrer
      }),
    );

    // configureCompat({ RENDER_FUNCTION: false, COMPILER_INLINE_TEMPLATE: true });
    app.config.compilerOptions.whitespace = 'preserve';
    app.config.compilerOptions.delimiters = ['[[', ']]'];
    app.config.compilerOptions.isCustomElement =
        tag => /^shop-|^bewerten-|^ents-|^suchen-|^kaufen-|^entd-|^brtn-|^camp-|^reco-|^additional-price-info|^loyl-|^klarna-placement/.test(tag);

    app.mount(appRoot);
  }
}

safeDefine('bewerten-vue-data', BewertenVueData);
